module.exports = __webpack_public_path__ + "img/logo@full.840f6069.png";